import { useEffect, useState } from "react";
import styles from "./Faculties.module.scss";
import { useLocation } from "react-router-dom";
import { getUnitFaculties } from "Admin/Service/Unit";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { FacultyCard, LoadingListCard, PaginationList } from "Admin/Components";
import { List } from "antd";
const Faculties = () => {
  const entity_id = useLocation().pathname.split("/")[3].split("-")[0];
  const entity_type = useLocation().pathname.split("/")[3].split("-")[1];
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 12,
    totalRows: 0,
  });
  const [data, setData] = useState({ data: [], isLoading: true });
  useEffect(() => {
    getUnitFaculties(
      entity_id,
      entity_type,
      pagination.page - 1,
      pagination.rowsPerPage,
      (res) => {
        handleAPIResponse(res, () => {
          setData({
            data: res.data.faculty_members,
            isLoading: false,
          });
          if (res.data.total) {
            setPagination({
              ...pagination,
              totalRows: res.data.total,
            });
          }
        });
      }
    );
  }, [pagination.page, pagination.rowsPerPage]);
  return (
    <div className={styles["unit-faculties"]}>
      <LoadingListCard
        isLoading={data.isLoading}
        grid={{
          gutter: 25,
          column: 4,
        }}
        componentNum={20}
        component={
          <div className={styles["content-venue"]}>
            <List
              grid={{
                gutter: 25,
                column: 4,
              }}
              dataSource={data.data}
              renderItem={(item, index) => {
                return (
                  <List.Item key={index}>
                    <FacultyCard data={item} />
                  </List.Item>
                );
              }}
            />
          </div>
        }
      />
      <PaginationList pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

export default Faculties;
